import { Entity } from '../../index.js';
import { appliesToCaseGroup, PropertyDataType, } from '../../properties/index.js';
import { ImportSheetType } from '../sheet-mapping.js';
import { helpers } from './index.js';
export const getKey = (handle) => `property_${handle}`;
export const getHandler = (propertyTypes, lang) => {
    const handler = {};
    for (let i = 0; i < propertyTypes.length; i++) {
        const propertyType = propertyTypes[i];
        const key = getKey(propertyType.handle);
        switch (propertyType.type) {
            case PropertyDataType.singleLineText:
                handler[key] = {
                    propertyRef: propertyType.ref,
                    propertyTypeId: propertyType.propertyTypeId,
                    map: [propertyType.label, propertyType.handle],
                    parser: (val) => helpers.stringParser(val),
                    validator: (val) => helpers.stringValidation(val, { nullable: !propertyType.required }),
                };
                break;
            case PropertyDataType.multiLineText:
                handler[key] = {
                    propertyRef: propertyType.ref,
                    propertyTypeId: propertyType.propertyTypeId,
                    map: [propertyType.label, propertyType.handle],
                    parser: (val) => helpers.stringParser(val),
                    validator: (val) => helpers.stringValidation(val, { nullable: !propertyType.required }),
                };
                break;
            case PropertyDataType.number:
                handler[key] = {
                    propertyRef: propertyType.ref,
                    propertyTypeId: propertyType.propertyTypeId,
                    map: [propertyType.label, propertyType.handle],
                    format: 'number',
                    parser: (val) => helpers.numberParser(val, {
                        float: true,
                        allowZero: true,
                    }),
                    validator: (val) => helpers.numberValidation(val, !propertyType.required),
                };
                break;
            case PropertyDataType.dropdown:
                handler[key] = {
                    propertyRef: propertyType.ref,
                    propertyTypeId: propertyType.propertyTypeId,
                    map: [propertyType.label, propertyType.handle],
                    parser: (val) => helpers.stringParser(val),
                    validator: (val) => helpers.stringValidation(val, {
                        nullable: !propertyType.required,
                        restrictedPossibilities: propertyType.data?.options.map((option) => option.value),
                    }),
                };
                break;
            case PropertyDataType.checkbox:
                handler[key] = {
                    propertyRef: propertyType.ref,
                    propertyTypeId: propertyType.propertyTypeId,
                    map: [propertyType.label, propertyType.handle],
                    parser: (val) => helpers.booleanParser(val),
                    validator: (val) => helpers.booleanValidation(val, !propertyType.required),
                };
                break;
            case PropertyDataType.file:
                handler[key] = {
                    propertyRef: propertyType.ref,
                    propertyTypeId: propertyType.propertyTypeId,
                    map: [propertyType.label, propertyType.handle],
                    parser: (val) => helpers.stringParser(val),
                    validator: (val, options) => [
                        ...helpers.stringValidation(val, {
                            nullable: !propertyType.required,
                        }),
                        ...(typeof val === 'string' &&
                            val !== '' &&
                            options?.appendixNames !== undefined &&
                            !options.appendixNames.includes(val)
                            ? [
                                `${lang?.import.workbook.attachmentNotUploaded ?? 'Attachment has not been uploaded'}: ${val}`,
                            ]
                            : []),
                    ],
                };
                break;
            case PropertyDataType.datePicker:
                handler[key] = {
                    propertyRef: propertyType.ref,
                    propertyTypeId: propertyType.propertyTypeId,
                    map: [propertyType.label, propertyType.handle],
                    format: 'date',
                    parser: (val, options) => helpers.excelDateParser(val, options),
                    validator: (val) => helpers.dateValidation(val, !propertyType.required),
                };
                break;
            case PropertyDataType.money:
                handler[key] = {
                    propertyRef: propertyType.ref,
                    propertyTypeId: propertyType.propertyTypeId,
                    map: [propertyType.label, propertyType.handle],
                    format: 'money',
                    parser: (val) => helpers.moneyParser(val, { allowZero: true }),
                    validator: (val) => helpers.numberValidation(val, !propertyType.required),
                };
                break;
            case PropertyDataType.address:
                for (let i = 0; i < addressKeys.length; i++) {
                    const addressKey = addressKeys[i];
                    handler[`${key}_${addressKey}`] = {
                        propertyRef: propertyType.ref,
                        propertyTypeId: propertyType.propertyTypeId,
                        map: lang
                            ? [
                                `${propertyType.label} (${
                                // @ts-ignore
                                lang.import[addressKey] || addressKey})`,
                            ]
                            : [],
                        parser: (val) => helpers.stringParser(val),
                        validator: (val) => helpers.stringValidation(val, {
                            nullable: ['coAddress', 'country'].includes(addressKey)
                                ? true
                                : !propertyType.required,
                        }),
                    };
                }
                break;
            default:
                break;
        }
    }
    return handler;
};
export const addressKeys = [
    'address',
    'coAddress',
    'zipcode',
    'city',
    'country',
];
export default {
    getHandler,
};
export const getOtherCaseGroupHandler = (propertyTypes, sheetType, caseGroupId, lang) => getHandler(propertyTypes.filter((property) => !appliesToCaseGroup(property, caseGroupId) &&
    ((sheetType === ImportSheetType.Cases &&
        (property.ref === Entity.Case ||
            property.ref === Entity.CaseVoucher)) ||
        (sheetType === ImportSheetType.Vouchers &&
            property.ref === Entity.CaseVoucher))), lang);
//# sourceMappingURL=properties.js.map